import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './cover-image.module.scss';

const CoverImage = (props) => {
  return props.imageUrl ? (
    <div
      className={classnames(styles.container, props.className)}
      data-test-id="cover-image"
    >
      <img
        src={props.imageUrl}
        alt={props.alt}
        className="image"
        aria-hidden={Boolean(!props.alt)}
      />
    </div>
  ) : null;
};

CoverImage.propTypes = {
  imageUrl: PropTypes.string,
  alt: PropTypes.string,
  className: PropTypes.string,
};

export default CoverImage;
